import { isArray } from 'lodash';

export const serializeMail = mail => {
  const time = new Date(mail.created_at);
  return {
    ticketId: mail.ticket_id,
    chainId: mail.chain_id,
    message: mail.message,
    subject: mail.subject,
    type: 'email',
    name: mail.full_name,
    isIncoming: mail.is_incoming,
    time,
  };
};

export const serializeMails = mails => {
  if (!isArray(mails) && mails.length < 1) return null;

  return mails.map(mail => serializeMail(mail));
};
